import { render, staticRenderFns } from "./PublicHome.vue?vue&type=template&id=5373392e&scoped=true"
import script from "./PublicHome.vue?vue&type=script&lang=js"
export * from "./PublicHome.vue?vue&type=script&lang=js"
import style0 from "./PublicHome.vue?vue&type=style&index=0&id=5373392e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5373392e",
  null
  
)

export default component.exports